import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BiCarousel } from '@react-icons/all-files/bi/BiCarousel';
import { RiNumber1 } from '@react-icons/all-files/ri/RiNumber1';
import { RiNumber2 } from '@react-icons/all-files/ri/RiNumber2';
import { RiNumber3 } from '@react-icons/all-files/ri/RiNumber3';
import { ButtonGroupField, SelectField, ToggleField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import { useStoreItemsContext } from '../../../contexts/external/StoreItemsContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';
import { ProductTextBadgeList } from './ProductTextBadgeList.js';

var _excluded = ["children"];
var PRODUCT_LIST_TYPES = [{
  text: jsx(RiNumber1, null),
  value: 1,
  canUseType: ['none', 'banner', 'circle', 'small']
}, {
  text: jsx(RiNumber2, null),
  value: 2,
  canUseType: ['none', 'banner', 'circle', 'small']
}, {
  text: jsx(RiNumber3, null),
  value: 3,
  canUseType: ['none', 'small']
}, {
  text: jsx(BiCarousel, null),
  value: 'carousel',
  canUseType: ['none', 'small']
}];
var PRODUCT_BADGE_TYPES = [{
  text: 'none',
  value: 'none',
  canUseType: [1, 2, 3, 'carousel']
}, {
  text: 'banner',
  value: 'banner',
  canUseType: [1, 2]
}, {
  text: 'circle',
  value: 'circle',
  canUseType: [1, 2]
}, {
  text: 'small',
  value: 'small',
  canUseType: [1, 2, 3, 'carousel']
}];
function ProductListInspector(_ref) {
  var _value$props$badgeTyp;
  var value = _ref.value,
    onChange = _ref.onChange;
  var handleChangeTextBadgeList = function handleChangeTextBadgeList(newProductTextBadgeList) {
    onChange(_objectSpread2(_objectSpread2({}, value), {}, {
      props: _objectSpread2(_objectSpread2({}, value.props), {}, {
        products: _toConsumableArray(newProductTextBadgeList)
      })
    }));
  };
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uB9AC\uC2A4\uD2B8 \uC720\uD615"
  }, jsx(ButtonGroupField, {
    "data-testid": "productListType",
    name: "type",
    width: "100%",
    options: PRODUCT_LIST_TYPES.filter(function (type) {
      return type.canUseType.includes(value.props.badgeType);
    })
  })), jsx(FormContent, {
    header: "\uBC43\uC9C0 \uC720\uD615"
  }, jsx(SelectField, {
    "data-testid": "productListbadgeType",
    name: "badgeType",
    width: "100%"
    // type이 3, carousel인 경우 options 선택 불가능하도록 제외
    ,
    options: PRODUCT_BADGE_TYPES.filter(function (badgeType) {
      return badgeType.canUseType.includes(value.props.type);
    })
  })), jsx(BuyButtonForm, {
    value: value,
    onChange: onChange
  }), jsx(ProductTextBadgeList, {
    type: value.props.type,
    badgeType: (_value$props$badgeTyp = value.props.badgeType) !== null && _value$props$badgeTyp !== void 0 ? _value$props$badgeTyp : 'none',
    onChange: handleChangeTextBadgeList
  }));
}
function BuyButtonForm(_ref2) {
  var value = _ref2.value;
  var _value$props = value.props,
    type = _value$props.type,
    badgeType = _value$props.badgeType,
    useBuyButton = _value$props.useBuyButton;
  var _ref3 = value !== null && value !== void 0 ? value : {};
    _ref3.children;
    var others = _objectWithoutProperties(_ref3, _excluded);
  var _useStoreItemsContext = useStoreItemsContext(),
    setLogData = _useStoreItemsContext.setLogData;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var showUseBuyButton = [1, 2].includes(type) && badgeType !== 'banner';
  useEffect(function () {
    // useBuyButton true + 구매하기 버튼(showUseBuyButton) 노출 불가인 경우 -> false로 초기화
    if (useBuyButton && !showUseBuyButton) {
      setValue('useBuyButton', false);
    }
  }, [showUseBuyButton, useBuyButton]);
  return jsx(React__default.Fragment, null, showUseBuyButton ? jsx(FormContent, {
    header: "\uAD6C\uB9E4\uD558\uAE30 \uBC84\uD2BC \uC0AC\uC6A9"
  }, jsx(ToggleField, {
    name: "useBuyButton"
  })) : null, jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key
  }, setLogData === null || setLogData === void 0 ? void 0 : setLogData(others))));
}

export { PRODUCT_BADGE_TYPES, PRODUCT_LIST_TYPES, ProductListInspector };
//# sourceMappingURL=index.js.map
